import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAgentSidebar } from '@/components/layout/AgentSidebarContext'
import { Button } from '@/components/ui/button'

export function ResolveWithAssistantButton({ caseId }: { caseId: string }) {
  const { t } = useTranslation()
  const { openWithPrompt } = useAgentSidebar()
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => openWithPrompt(caseId, t('resolutionAssistant.prompt'))}
    >
      <Sparkles aria-hidden className="size-4" />
      {t('resolutionAssistant.launch')}
    </Button>
  )
}
